module.exports = __webpack_public_path__ + "static/media/classroom_view_navigate_video.55643d1d.mov";